module.exports = __webpack_public_path__ + "static/media/parallax.9df57be1.pdn";